import type { ComponentProps, ReactNode } from "react";

import { cn } from "@/lib/cn";

const control =
  "min-h-11 w-full rounded-md border border-line bg-surface px-3 text-base text-ink " +
  "placeholder:text-ink-3 focus-visible:border-info disabled:opacity-60";

export function Input({ className, ...props }: ComponentProps<"input">) {
  return <input className={cn(control, className)} {...props} />;
}

export function Select({ className, ...props }: ComponentProps<"select">) {
  return <select className={cn(control, "pr-8", className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<"textarea">) {
  return <textarea className={cn(control, "min-h-20 py-2", className)} {...props} />;
}

/** Etiqueta con su campo y, si hace falta, una ayuda o el error debajo. */
export function Field({
  label,
  htmlFor,
  hint,
  error,
  children,
}: {
  label: string;
  htmlFor: string;
  hint?: string;
  error?: string | null;
  children: ReactNode;
}) {
  return (
    <div className="grid gap-1">
      <label htmlFor={htmlFor} className="text-sm font-semibold text-ink">
        {label}
      </label>
      {children}
      {error ? (
        <p role="alert" className="text-sm text-bad">
          {error}
        </p>
      ) : hint ? (
        <p className="text-sm text-ink-3">{hint}</p>
      ) : null}
    </div>
  );
}

/** Campo numérico compacto para tablas: porcentajes y montos editables en fila. */
export function CellInput({ className, ...props }: ComponentProps<"input">) {
  return (
    <input
      inputMode="decimal"
      className={cn(
        "min-h-9 w-full min-w-16 rounded-sm border border-line bg-surface px-2 text-right font-mono text-sm tabular-nums text-ink",
        "hover:border-ink-3 focus-visible:border-info aria-invalid:border-bad aria-invalid:bg-bad-surface",
        className,
      )}
      {...props}
    />
  );
}
